import {GroupAvatar, Member, Membership, UserAvatar} from "@/lib/types";
import AvatarRow from "@/lib/components/AvatarRow";
import {Color, rowColor} from "@/lib/styles";
import AvatarTable from "@/lib/components/AvatarTable";

type Props = {
    members: Member[],
    color: string,
    contrastColor: string,
    colored: boolean,
    onPress: (avatar: UserAvatar | GroupAvatar) => any,
    onEdit?: (username: string) => any,
}

export default function MemberTable({members, color, contrastColor, colored, onPress, onEdit}: Props) {
    const baseColor = colored ? color : Color.Container;

    function badge(member: Member): string | undefined {
        if (member.status === Membership.ADMINISTRATOR) {
            return 'Admin';
        } else if (member.status === Membership.MODERATOR) {
            return 'Moderator';
        }
    }

    return (
        <AvatarTable>
            {members.map((participant, index) => (
                <AvatarRow key={participant.avatar.id}
                           avatar={participant.avatar}
                           badge={badge(participant)}
                           badgeColor={color}
                           color={rowColor(baseColor, index)}
                           contrastColor={contrastColor}
                           onPress={onPress}
                           onEdit={onEdit ? onEdit(participant.avatar.username) : undefined}
                />
            ))}
        </AvatarTable>
    )
}